const TERMINAL_STATUSES = new Set(['ready', 'failed']);

// Bound wrappers, not bare references: `setTimeout`/`clearTimeout` are
// WindowOrWorkerGlobalScope methods, and a browser throws "Illegal
// invocation" the moment one is invoked as `this.schedule(...)` with some
// receiver other than the global object — exactly what a bare default
// parameter (`schedule = setTimeout`) hands to `this.schedule` below.
// Wrapping keeps the global object as the receiver regardless of how the
// method is later called. globalThis (not window) so this also works
// unmodified under plain Node, e.g. in this file's own test suite.
const defaultSchedule = (...args) => globalThis.setTimeout(...args);
const defaultCancel = (...args) => globalThis.clearTimeout(...args);

export class ProcessingStatusPoller {
  constructor({ url, fetchStatus, onTerminal, schedule = defaultSchedule, cancel = defaultCancel, interval = 5000, maxInterval = 15000 }) {
    this.url = url;
    this.fetchStatus = fetchStatus;
    this.onTerminal = onTerminal;
    this.schedule = schedule;
    this.cancel = cancel;
    this.interval = interval;
    this.maxInterval = maxInterval;
    this.currentInterval = interval;
    this.timer = null;
    this.stopped = true;
  }

  start() {
    if (!this.stopped) return;

    this.stopped = false;
    this.queue();
  }

  stop() {
    this.stopped = true;
    if (this.timer !== null) this.cancel(this.timer);
    this.timer = null;
  }

  queue() {
    this.timer = this.schedule(() => this.poll(), this.currentInterval);
  }

  async poll() {
    if (this.stopped) return;

    try {
      const response = await this.fetchStatus(this.url);
      if (!response.ok) throw new Error(`Processing status request failed (${response.status})`);

      const { status } = await response.json();
      if (TERMINAL_STATUSES.has(status)) {
        this.stop();
        this.onTerminal(status);
        return;
      }

      this.currentInterval = this.interval;
    } catch (_error) {
      this.currentInterval = Math.min(this.currentInterval * 2, this.maxInterval);
    }

    if (!this.stopped) this.queue();
  }
}
